/* eslint-disable jsx-a11y/alt-text */

// TODO keep displaying timer for a few seconds after done
// TODO other visual timer controls

import React, {useState, useEffect, useCallback} from "react";
import {useAtomValue} from "jotai";
import {timersAtom, finishTimer, updateTimer, renameTimer, TimerT, deleteTimer} from "../state/timer";
import {activesAtom, sessionIdAtom} from "../state/active";
import {get_hms, time_string, logState} from "../utils";

import styles from "./Timer.module.css";
import gStyles from "../App.module.css";
Object.assign(styles, gStyles);

// Timer component
// This both displays the timer, as well as updates the timer every second
function Timer({timer}: {timer: TimerT}) {
  const now = new Date();
  const {name, end} = timer;
  const actives = useAtomValue(activesAtom);
  const colorByName = {};
  Object.values(actives).forEach((active) => {
    colorByName[active.name] = active.color;
  });
  //console.log("in timer", timer, now, colorByName);

  const [timeLeft, setTimeLeft] = useState((end - now) / 1000);
  //console.log("time left", timeLeft);
  // the actual timer
  const [t, setT] = useState(null);
  // function that checks the timer and updates the time left, and calls finishTimer() if done
  const checkTimer = useCallback(() => {
    const now = new Date();
    const timeLeft = (end - now) / 1000;
    //console.log('checking timer', end, (end-now)/1000, timeLeft);
    if (timeLeft <= 0) {
      clearTimeout(t);
      console.log("calling finish timer", t);
      setT(null);
      finishTimer(name);
    } else {
      setTimeLeft(timeLeft);
      setT(setTimeout(checkTimer, 1000));
    }
  }, [end, name, t]);

  // start the timer on first render and when 'end' changes
  useEffect(() => {
    if (t) {
      clearTimeout(t);
    }
    checkTimer();
    //setT(setTimeout(checkTimer, 1000));
  }, [end, name]);

  // actually render the timer
  const time_str = time_string(get_hms(timeLeft), ":");
  const iconStyle = {position: "relative", top: 1, width: 15};
  const renameTimerDialog = () => {
    const newName = prompt("Enter new timer name");
    if (newName && newName !== name) {
      renameTimer(name, newName);
    }
  }
  return (
    <div className={styles.timer} style={{backgroundColor: colorByName[timer.recipeName] || null}}>
      <img src="/icons/cancel-timer.png" onDoubleClick={() => deleteTimer(name)} style={{marginRight: 3, ...iconStyle}} />
      <span onClick={renameTimerDialog}>{name}</span> {time_str}
      <img src="/icons/add-time.png" onClick={() => updateTimer(name, 30000, true)} style={{marginLeft: 3, ...iconStyle}} />
    </div>
  );
}

export function Timers() {
  const timers = useAtomValue(timersAtom);
  const sessionId = useAtomValue(sessionIdAtom);
  console.log("got timers", timers);
  useEffect(() => {
    logState({_name: "timer-timers", sessionId, ...timers});
  }, [timers]);
  return (
    <div className={`${styles.timers} ${styles.navbar}`}>
      <img src="/icons/clock.png" style={{position: "relative", top: 3, width: 15}} />
      {Object.values(timers).map((timer) => (
        <Timer timer={timer} key={timer.name} />
      ))}
    </div>
  );
}
